import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

/** Simulates a network request so loading states are exercised.
 *  Replace with a real HttpClient call when a REST API is wired up. */
export function mockRequest<T>(value: T, ms = 350) {
  return of(value).pipe(delay(ms));
}

export function uid(prefix = 'id'): string {
  return `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
}
